import { render } from "./BookmarkIcon.vue?vue&type=template&id=e41fe5a4&ts=true"
import script from "./BookmarkIcon.vue?vue&type=script&lang=ts"
export * from "./BookmarkIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__